import React, { FunctionComponent } from 'react';
import { ErrorAlert } from '../ErrorAlert';
import { DiagnosisImage } from './imageDiagnosisTypes';
import { Button } from '../Button';
import { Heading } from '../Typography';

interface ImageSelectorProps {
  fieldName: string;
  fieldLabel?: string;
  diagnosisImages: DiagnosisImage[];
  currentlySelectedImage: number;
  setCurrentlySelectedImage: (imageIndex: number) => void;
  children: React.ReactNode;
}

// ImageSelector allows for the user to select which image is displayed (e.g. in the case of dog diagnosis, the user
// can select between the right and left sides of the dog).
export const ImageSelector: FunctionComponent<ImageSelectorProps> = ({
  fieldName,
  fieldLabel = '',
  children,
  diagnosisImages,
  currentlySelectedImage,
  setCurrentlySelectedImage
}) => {
  if (!diagnosisImages || diagnosisImages.length === 0) {
    return <ErrorAlert title="Unable to Display" message="No images provided for diagnosis." />;
  }

  return (
    <div className="inline-flex min-w-[700px] flex-col gap-4 rounded-xl border border-primary/40 bg-widget px-4 py-2">
      <div className="mb-4 flex flex-row justify-between align-middle">
        <Heading level="section" as="div">
          {fieldLabel}
        </Heading>
        <div className="space-x-2">
          {diagnosisImages.map((diagnosisImage, pageIndex) => (
            <Button
              key={`image-btn-${fieldName}-${diagnosisImage.name}`}
              onClick={() => setCurrentlySelectedImage(pageIndex)}
              size="small"
              variant={currentlySelectedImage === pageIndex ? 'primary' : 'outline'}
            >
              {diagnosisImage.name}
            </Button>
          ))}
        </div>
      </div>
      <div className="flex flex-row items-center justify-center">{children}</div>
    </div>
  );
};
